import type React from "react"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/hooks/use-auth"
import { useAuthModal } from "@/hooks/use-auth-modal"

interface AuthButtonProps {
  children: React.ReactNode
  isAuthenticated?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link"
  size?: "default" | "sm" | "lg" | "icon"
  className?: string
  disabled?: boolean
  authAction?: "login" | "register"
  authMessage?: string
  type?: "button" | "submit" | "reset"
}

export function AuthButton({
  children,
  isAuthenticated,
  onClick,
  variant = "default",
  size = "default",
  className,
  disabled = false,
  authAction = "login",
  type,
  ...props
}: AuthButtonProps) {
  const { openModal } = useAuthModal()
  const { isAuthenticated: globalIsAuthenticated } = useAuth()

  const authenticated = isAuthenticated ?? globalIsAuthenticated

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!authenticated) {
      e.preventDefault()
      e.stopPropagation()
      openModal(authAction)
      return
    }
    onClick?.(e)
  }

  return (
    <Button
      onClick={handleClick}
      variant={variant}
      size={size}
      className={className}
      disabled={disabled}
      type={type}
      {...props}
    >
      {children}
    </Button>
  )
}
